import { observer } from 'mobx-react';
import { ImportedParticipantsResource, ViewReportAction } from '../../Store/Types';
import Body from './Body';
import Head from './Head';

interface Props {
  importedParticipantsResource: ImportedParticipantsResource;
  viewReport: ViewReportAction;
}

function Table({ importedParticipantsResource, viewReport }: Props) {
  return (
    <table className="min-w-full divide-y divide-gray-300 ">
      <Head />
      <Body viewReport={viewReport} importedParticipantsResource={importedParticipantsResource} />
    </table>
  );
}

export default observer(Table);
